import api from "../../../shared/services/api";

export async function listTemplates(contaId, { status, category, language } = {}) {
  const params = {};
  if (status) params.status = status;
  if (category) params.category = category;
  if (language) params.language = language;
  const response = await api.get(`/whatsapp/meta/contas/${contaId}/templates`, { params });
  return response.data?.data || [];
}

export async function createTemplate(contaId, { name, language, category, components }) {
  const response = await api.post(`/whatsapp/meta/contas/${contaId}/templates`, {
    name,
    language,
    category,
    components,
  });
  return response.data?.template;
}

export async function deleteTemplate(contaId, templateId) {
  const response = await api.delete(`/whatsapp/meta/contas/${contaId}/templates/${templateId}`);
  return response.data;
}

export async function syncTemplates(contaId) {
  const response = await api.post(`/whatsapp/meta/contas/${contaId}/templates/sync`);
  return response.data;
}
